export function classes(...list) {
  return list.flat().filter(x => x).join(' ');
}